import { ClasePerdida, ClasePerdidaMCP } from '../models';

/* NgRx */
import { createReducer, on } from '@ngrx/store';
import { ClasePerdidaApiActions, ClasePerdidaPageActions } from './actions';
import { MateriaMin } from 'src/app/unidad-buscar/models/unidad-setup';

// State for this feature (ClasePerdida)
export interface ClasePerdidaState {
  loading: boolean;
  error: string;
  perdidas: ClasePerdida[];
  current: ClasePerdida;
  currentClasePerdidaId: number;
  idUnidad: number;
  materias: MateriaMin[];
  perdidasGlobal: ClasePerdidaMCP[];
  selectedMCPId: number[];
}

const initialState: ClasePerdidaState = {
  loading: false,
  error: '',
  perdidas: [],
  current: null,
  currentClasePerdidaId: 0,
  idUnidad: 0,
  materias: [],
  perdidasGlobal: [],
  selectedMCPId: [],
};

export const clasePerdidaReducer = createReducer<ClasePerdidaState>(
  initialState,
  on(ClasePerdidaPageActions.setIdUnidad, (state, action): ClasePerdidaState => {
    return {
      ...state,
      idUnidad: action.idUnidad
    };
  }),
  on(ClasePerdidaPageActions.setCurrentClasePerdida, (state, action): ClasePerdidaState => {
    return {
      ...state,
      currentClasePerdidaId: action.currentClasePerdidaId
    };
  }),
  on(ClasePerdidaPageActions.clearCurrentClasePerdida, (state): ClasePerdidaState => {
    return {
      ...state,
      currentClasePerdidaId: null
    };
  }),
  on(ClasePerdidaPageActions.initializeCurrentClasePerdida, (state): ClasePerdidaState => {
    return {
      ...state,
      currentClasePerdidaId: 0
    };
  }),
  on(ClasePerdidaApiActions.loadUnidadMateriasSuccess, (state, action): ClasePerdidaState => {
    return {
      ...state,
      materias: action.materias,
      loading: false,
      error: ''
    };
  }),
  on(ClasePerdidaApiActions.loadUnidadMateriasFailure, (state, action): ClasePerdidaState => {
    return {
      ...state,
      materias: [],
      loading: false,
      error: action.error
    };
  }),
  on(ClasePerdidaPageActions.loadClasePerdidas, (state): ClasePerdidaState => {
    return {
      ...state,
      loading: true
    };
  }),
  on(ClasePerdidaApiActions.loadClasePerdidasSuccess, (state, action): ClasePerdidaState => {
    return {
      ...state,
      perdidas: action.clasePerdidas,
      error: ''
    };
  }),
  on(ClasePerdidaApiActions.loadClasePerdidasFailure, (state, action): ClasePerdidaState => {
    return {
      ...state,
      perdidas: [],
      error: action.error
    };
  }),
  on(ClasePerdidaPageActions.deleteClasePerdida, (state): ClasePerdidaState => {
    return {
      ...state,
      loading: true
    };
  }),
  on(ClasePerdidaApiActions.deleteClasePerdidaSuccess, (state, action): ClasePerdidaState => {
    // const deleted = state.perdidas.map(
    //   item => action.clasePerdida.id === item.id ? action.clasePerdida : item);
    return {
      ...state,
      perdidas: state.perdidas.filter(perdida => perdida.id !== action.clasePerdida.id),
      currentClasePerdidaId: null,
      loading: false,
      error: ''
    };
  }),
  on(ClasePerdidaApiActions.deleteClasePerdidaFailure, (state, action): ClasePerdidaState => {
    return {
      ...state,
      loading: false,
      error: action.error
    };
  }),
  on(ClasePerdidaPageActions.createClasePerdida, (state): ClasePerdidaState => {
    return {
      ...state,
      loading: true
    };
  }),
  on(ClasePerdidaApiActions.updateClasePerdidaSuccess, (state, action): ClasePerdidaState => {
    const updated = state.perdidas.map(
      item => action.clasePerdida.id === item.id ? action.clasePerdida : item);
    return {
      ...state,
      perdidas: updated,
      currentClasePerdidaId: action.clasePerdida.id,
      loading: false,
      error: ''
    };
  }),
  on(ClasePerdidaApiActions.updateClasePerdidaFailure, (state, action): ClasePerdidaState => {
    return {
      ...state,
      loading: false,
      error: action.error
    };
  }),
  // After a create, the currentClasePerdida is the new product.
  on(ClasePerdidaApiActions.createClasePerdidaSuccess, (state, action): ClasePerdidaState => {
    return {
      ...state,
      perdidas: [...state.perdidas, action.clasePerdida],
      currentClasePerdidaId: action.clasePerdida.id,
      loading: false,
      error: ''
    };
  }),
  on(ClasePerdidaApiActions.createClasePerdidaFailure, (state, action): ClasePerdidaState => {
    return {
      ...state,
      loading: false,
      error: action.error
    };
  }),
);
